import React, { useState, useEffect } from 'react';

const GOLD='#F5A623',DARK='#2C2C2A',NAVY='#1E3A5F',GREEN='#22C55E',RED='#EF4444',PURPLE='#7C3AED';
const s = {
  card:{background:'#fff',border:'0.5px solid #D3D1C7',borderRadius:'14px',padding:'16px 20px',marginBottom:'10px'},
  btn:{padding:'8px 16px',borderRadius:'9px',fontSize:'12px',fontWeight:700,cursor:'pointer',border:'none',fontFamily:"'Syne',sans-serif"},
  input:{background:'#F4F4F4',border:'0.5px solid #D3D1C7',borderRadius:'9px',padding:'9px 13px',fontSize:'13px',width:'100%',fontFamily:"'Syne',sans-serif",outline:'none',boxSizing:'border-box'},
  label:{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'4px',display:'block'},
  th:{background:'#F4F4F4',padding:'8px 12px',fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',textAlign:'left',borderBottom:'1px solid #E5E5E5'},
  td:{padding:'10px 12px',fontSize:'12px',borderBottom:'0.5px solid #F0F0F0',verticalAlign:'middle'},
};

const api = async (endpoint, options={}) => {
  const token = localStorage.getItem('token');
  const res = await fetch('/api' + endpoint, {
    headers:{'Content-Type':'application/json',...(token?{Authorization:'Bearer '+token}:{})},
    ...options
  });
  return res.json();
};

const apiForm = async (endpoint, formData) => {
  const token = localStorage.getItem('token');
  const res = await fetch('/api' + endpoint, {
    method:'POST',
    headers:{...(token?{Authorization:'Bearer '+token}:{})},
    body: formData,
  });
  return res.json();
};

const Toggle = ({ checked, onChange }) => (
  <label style={{position:'relative',width:'40px',height:'22px',display:'inline-block',cursor:'pointer'}}>
    <input type="checkbox" checked={checked} onChange={onChange} style={{opacity:0,width:0,height:0,position:'absolute'}}/>
    <div style={{position:'absolute',inset:0,background:checked?GREEN:'#D3D1C7',borderRadius:'11px',transition:'background .2s'}}/>
    <div style={{position:'absolute',top:'3px',left:checked?'21px':'3px',width:'16px',height:'16px',background:'white',borderRadius:'50%',transition:'left .2s',pointerEvents:'none'}}/>
  </label>
);

const StatCard = ({ icon, label, value, sub, color }) => (
  <div style={{...s.card,display:'flex',alignItems:'center',gap:'14px',padding:'14px 16px'}}>
    <div style={{width:'44px',height:'44px',borderRadius:'10px',background:color+'20',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'20px',flexShrink:0}}>{icon}</div>
    <div style={{flex:1}}>
      <div style={{fontSize:'22px',fontWeight:800,color,lineHeight:1}}>{value}</div>
      <div style={{fontSize:'11px',color:'#888',marginTop:'2px'}}>{label}</div>
      {sub && <div style={{fontSize:'10px',color,marginTop:'1px'}}>{sub}</div>}
    </div>
  </div>
);

function Modal({ title, onClose, children, maxWidth='500px' }) {
  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999,padding:'16px'}}>
      <div style={{background:'#fff',borderRadius:'14px',maxWidth,width:'100%',maxHeight:'90vh',overflowY:'auto'}}>
        <div style={{background:NAVY,padding:'14px 20px',display:'flex',alignItems:'center',justifyContent:'space-between',borderRadius:'14px 14px 0 0'}}>
          <div style={{color:'#fff',fontWeight:800,fontSize:'15px'}}>{title}</div>
          <button onClick={onClose} style={{background:'rgba(255,255,255,.15)',border:'none',borderRadius:'8px',padding:'5px 10px',color:'#fff',cursor:'pointer',fontSize:'14px'}}>✕</button>
        </div>
        <div style={{padding:'20px'}}>{children}</div>
      </div>
    </div>
  );
}

const DOC_LABELS = {buletin:'🪪 Buletin/CI',civ:'🪪 CIV',talon:'📄 Talon',polita_rca:'🛡️ Polița RCA',polita_casco:'🚗 Polița CASCO',dovada_itp:'🔍 Dovadă ITP',dovada_rovinieta:'🛣️ Rovinieta',contract_vanzare:'📝 Contract vânzare',certificat_radiere:'📋 Certificat radiere'};

function VehicleDosarModal({ vehicle, userId, onClose }) {
  const [docs, setDocs] = useState([]);
  const [expiry, setExpiry] = useState({ rca_expiry:'', casco_expiry:'', itp_expiry:'', rovinieta_expiry:'' });
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadType, setUploadType] = useState('talon');
  const [msg, setMsg] = useState('');
  const [saving, setSaving] = useState(false);

  const loadDocs = () => api(`/admin/vehicles/${vehicle.id}/documents`).then(d => d.documents && setDocs(d.documents));

  useEffect(() => {
    loadDocs();
    setExpiry({
      rca_expiry: vehicle.rca_expiry ? vehicle.rca_expiry.split('T')[0] : '',
      casco_expiry: vehicle.casco_expiry ? vehicle.casco_expiry.split('T')[0] : '',
      itp_expiry: vehicle.itp_expiry ? vehicle.itp_expiry.split('T')[0] : '',
      rovinieta_expiry: vehicle.rovinieta_expiry ? vehicle.rovinieta_expiry.split('T')[0] : '',
    });
  }, [vehicle.id]);

  const saveExpiry = async () => {
    setSaving(true);
    const d = await api(`/admin/vehicles/${vehicle.id}/expiry`, { method:'PUT', body: JSON.stringify(expiry) });
    setMsg(d.message ? '✓ ' + d.message : d.error || 'Eroare');
    setSaving(false);
    setTimeout(() => setMsg(''), 3000);
  };

  const uploadDoc = async () => {
    if (!uploadFile) { setMsg('Selectează un fișier.'); return; }
    setSaving(true);
    const fd = new FormData();
    fd.append('file', uploadFile);
    fd.append('vehicle_id', vehicle.id);
    fd.append('doc_type', uploadType);
    const d = await apiForm(`/admin/users/${userId}/documents`, fd);
    setMsg(d.document ? '✓ Document adăugat.' : d.error || 'Eroare upload');
    setUploadFile(null);
    if (d.document) loadDocs();
    setSaving(false);
    setTimeout(() => setMsg(''), 3000);
  };

  const deleteDoc = async (id) => {
    const d = await api(`/admin/documents/${id}`, { method:'DELETE' });
    setMsg(d.message ? '✓ ' + d.message : d.error || 'Eroare');
    loadDocs();
    setTimeout(() => setMsg(''), 3000);
  };

  return (
    <Modal title={`📂 Dosar — ${vehicle.plate_number || vehicle.vin || 'vehicul'}`} onClose={onClose} maxWidth='560px'>
      {msg && <div style={{background:msg.includes('✓')?'#DCFCE7':'#FEE2E2',borderRadius:'8px',padding:'9px 12px',fontSize:'12px',color:msg.includes('✓')?'#15803D':'#B91C1C',marginBottom:'12px'}}>{msg}</div>}

      {/* Documente existente */}
      <div style={{fontWeight:700,fontSize:'13px',marginBottom:'8px'}}>📄 Documente ({docs.length})</div>
      {docs.length === 0 ? (
        <div style={{background:'#F4F4F4',borderRadius:'8px',padding:'14px',fontSize:'12px',color:'#888',marginBottom:'14px',textAlign:'center'}}>Niciun document încărcat</div>
      ) : (
        <div style={{marginBottom:'14px'}}>
          {docs.map(d => (
            <div key={d.id} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'8px 12px',borderBottom:'0.5px solid #F0F0F0'}}>
              <div>
                <div style={{fontSize:'12px',fontWeight:700}}>{DOC_LABELS[d.doc_type]||d.doc_type}</div>
                <div style={{fontSize:'10px',color:'#888'}}>{d.original_filename} · {d.file_size_bytes ? Math.round(d.file_size_bytes/1024)+'KB' : ''}</div>
              </div>
              <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                <a href={'/api' + d.s3_key} target="_blank" rel="noreferrer"
                  style={{...s.btn,background:'#E8EEF5',color:NAVY,padding:'5px 10px',fontSize:'11px',textDecoration:'none',display:'inline-block'}}>
                  ↗ Deschide
                </a>
                <button onClick={() => deleteDoc(d.id)} style={{...s.btn,background:'#FEE2E2',color:RED,padding:'5px 10px',fontSize:'11px'}}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Upload document */}
      <div style={{background:'#F4F4F4',borderRadius:'10px',padding:'14px',marginBottom:'16px'}}>
        <div style={{fontWeight:700,fontSize:'12px',marginBottom:'10px'}}>➕ Adaugă document</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px',marginBottom:'8px'}}>
          <div>
            <label style={s.label}>Tip document</label>
            <select value={uploadType} onChange={e=>setUploadType(e.target.value)} style={s.input}>
              {Object.entries(DOC_LABELS).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
          <div>
            <label style={s.label}>Fișier</label>
            <input type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={e=>setUploadFile(e.target.files[0])}
              style={{...s.input,padding:'6px',fontSize:'11px'}}/>
          </div>
        </div>
        <button onClick={uploadDoc} disabled={saving} style={{...s.btn,background:GOLD,color:DARK,width:'100%'}}>
          {saving?'Se încarcă...':'📤 Încarcă document'}
        </button>
      </div>

      {/* Expirări */}
      <div style={{fontWeight:700,fontSize:'13px',marginBottom:'10px'}}>⏰ Setează expirări</div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'8px',marginBottom:'10px'}}>
        {[['rca_expiry','🛡️ RCA'],['itp_expiry','🔍 ITP'],['casco_expiry','🚗 CASCO'],['rovinieta_expiry','🛣️ Rovinieta']].map(([k,label]) => (
          <div key={k}>
            <label style={s.label}>{label}</label>
            <input type="date" style={s.input} value={expiry[k]} onChange={e=>setExpiry({...expiry,[k]:e.target.value})}/>
          </div>
        ))}
      </div>
      <button onClick={saveExpiry} disabled={saving} style={{...s.btn,background:NAVY,color:'#fff',width:'100%'}}>
        {saving?'Se salvează...':'💾 Salvează expirările'}
      </button>
    </Modal>
  );
}

function EditUserModal({ user, onClose, onSaved }) {
  const [form, setForm] = useState({ first_name: user.first_name||'', last_name: user.last_name||'', phone: user.phone||'', password:'' });
  const [msg, setMsg] = useState('');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    const d = await api(`/admin/users/${user.id}`, { method:'PATCH', body: JSON.stringify(form) });
    if (d.message) { setMsg('✓ ' + d.message); setTimeout(() => { onSaved(); onClose(); }, 800); }
    else setMsg(d.error || 'Eroare');
    setSaving(false);
  };

  return (
    <Modal title={`✏️ Editare client — ${user.email}`} onClose={onClose} maxWidth='440px'>
      {msg && <div style={{background:msg.includes('✓')?'#DCFCE7':'#FEE2E2',borderRadius:'8px',padding:'9px 12px',fontSize:'12px',color:msg.includes('✓')?'#15803D':'#B91C1C',marginBottom:'12px'}}>{msg}</div>}
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'14px'}}>
        <div><label style={s.label}>Prenume</label><input style={s.input} value={form.first_name} onChange={e=>setForm({...form,first_name:e.target.value})}/></div>
        <div><label style={s.label}>Nume</label><input style={s.input} value={form.last_name} onChange={e=>setForm({...form,last_name:e.target.value})}/></div>
        <div><label style={s.label}>Telefon</label><input style={s.input} value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})}/></div>
        <div><label style={s.label}>Parolă nouă</label><input type="password" style={s.input} value={form.password} onChange={e=>setForm({...form,password:e.target.value})} placeholder="Lasă gol = nemodificată"/></div>
      </div>
      <div style={{display:'flex',gap:'8px'}}>
        <button onClick={save} disabled={saving} style={{...s.btn,background:GOLD,color:DARK,flex:1}}>{saving?'Se salvează...':'Salvează'}</button>
        <button onClick={onClose} style={{...s.btn,background:'#F4F4F4',color:'#555',border:'0.5px solid #D3D1C7'}}>Anulează</button>
      </div>
    </Modal>
  );
}

function UserVehiclesModal({ user, onClose }) {
  const [vehicles, setVehicles] = useState([]);
  const [dosar, setDosar] = useState(null);

  useEffect(() => {
    api(`/admin/users/${user.id}/vehicles`).then(d => d.vehicles && setVehicles(d.vehicles));
  }, [user.id]);

  if (dosar) return <VehicleDosarModal vehicle={dosar} userId={user.id} onClose={() => setDosar(null)}/>;

  return (
    <Modal title={`🚗 Mașinile lui ${user.first_name||''} ${user.last_name||user.email}`} onClose={onClose} maxWidth='560px'>
      {vehicles.length === 0 ? (
        <div style={{textAlign:'center',padding:'24px',color:'#888',fontSize:'13px'}}>Niciun vehicul înregistrat</div>
      ) : vehicles.map(v => (
        <div key={v.id} style={{...s.card,display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'8px'}}>
          <div>
            <div style={{fontFamily:'monospace',fontWeight:700,color:GOLD,fontSize:'14px'}}>{v.plate_number||v.vin||'—'}</div>
            <div style={{fontSize:'12px',color:'#555'}}>{v.brand} {v.model} {v.year}</div>
            <div style={{fontSize:'10px',color:'#888'}}>{v.doc_count} documente</div>
          </div>
          <button onClick={() => setDosar(v)} style={{...s.btn,background:'#E8EEF5',color:NAVY,padding:'7px 14px'}}>📂 Dosar</button>
        </div>
      ))}
    </Modal>
  );
}

function CreateClientWizard({ onClose, onCreated }) {
  const [step, setStep] = useState(1);
  const [mode, setMode] = useState('upload'); // 'upload' | 'manual'
  const [talonFile, setTalonFile] = useState(null);
  const [buletinFile, setBuletinFile] = useState(null);
  const [talonOcr, setTalonOcr] = useState(null);   // extracted vehicle data
  const [buletinOcr, setBuletinOcr] = useState(null); // extracted owner data
  const [ocrLoading, setOcrLoading] = useState({ talon: false, buletin: false });
  const [client, setClient] = useState({ email: '', password: '', first_name: '', last_name: '', phone: '' });
  const [vehicle, setVehicle] = useState({ plate_number: '', brand: '', model: '', year: '', vin: '', fuel_type: '', engine_cc: '', power_kw: '' });
  const [expiry, setExpiry] = useState({ rca_expiry: '', casco_expiry: '', itp_expiry: '', rovinieta_expiry: '' });
  const [result, setResult] = useState(null);
  const [msg, setMsg] = useState('');
  const [saving, setSaving] = useState(false);

  const genPassword = () => {
    const chars = 'abcdefghijkmnpqrstuvwxyz23456789';
    return Array.from({ length: 8 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  };

  useEffect(() => {
    setClient(c => ({ ...c, password: genPassword() }));
  }, []);

  // Run OCR on uploaded file
  const runOcr = async (file, docType, which) => {
    setOcrLoading(l => ({ ...l, [which]: true }));
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('doc_type', docType);
      const token = localStorage.getItem('token');
      const res = await fetch('/api/admin/ocr-file', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token },
        body: fd,
      });
      const d = await res.json();
      if (d.data) {
        if (which === 'talon') {
          setTalonOcr(d.data);
          setVehicle(v => ({
            ...v,
            plate_number: d.data.plate_number || v.plate_number,
            brand: d.data.brand || v.brand,
            model: d.data.model || v.model,
            year: d.data.year ? String(d.data.year) : v.year,
            vin: d.data.vin || v.vin,
            fuel_type: d.data.fuel_type || v.fuel_type,
            engine_cc: d.data.engine_cc ? String(d.data.engine_cc) : v.engine_cc,
            power_kw: d.data.power_kw ? String(d.data.power_kw) : v.power_kw,
          }));
        } else {
          setBuletinOcr(d.data);
          setClient(c => ({
            ...c,
            first_name: d.data.first_name || c.first_name,
            last_name: d.data.last_name || c.last_name,
          }));
        }
      } else {
        setMsg('OCR nu a putut extrage date. Completează manual câmpurile.');
      }
    } catch { setMsg('Eroare OCR. Completează manual.'); }
    setOcrLoading(l => ({ ...l, [which]: false }));
  };

  const handleTalonUpload = (file) => {
    if (!file) return;
    setTalonFile(file);
    runOcr(file, 'talon', 'talon');
  };

  const handleBuletinUpload = (file) => {
    if (!file) return;
    setBuletinFile(file);
    runOcr(file, 'ci_proprietar', 'buletin');
  };

  const canContinueStep1 = mode === 'manual'
    ? (client.first_name.trim() && client.last_name.trim() && client.email.trim() && client.password.trim())
    : talonFile !== null;

  const createClient = async () => {
    if (!client.email || !client.password) { setMsg('Email și parola sunt obligatorii.'); return; }
    setSaving(true);
    const d = await api('/admin/create-client', {
      method: 'POST',
      body: JSON.stringify({ ...client, ...vehicle, ...expiry }),
    });
    if (d.user) {
      // Upload files to new user's dosar if they exist
      if (d.vehicle && (talonFile || buletinFile)) {
        const uploads = [];
        if (talonFile) uploads.push({ file: talonFile, type: 'talon' });
        if (buletinFile) uploads.push({ file: buletinFile, type: 'ci_proprietar' });
        const token = localStorage.getItem('token');
        for (const u of uploads) {
          try {
            const fd = new FormData();
            fd.append('file', u.file);
            fd.append('vehicle_id', d.vehicle.id);
            fd.append('doc_type', u.type);
            await fetch('/api/admin/users/' + d.user.id + '/documents', {
              method: 'POST',
              headers: { Authorization: 'Bearer ' + token },
              body: fd,
            });
          } catch (e) {}
        }
      }
      setResult({ ...d, password: client.password });
    } else {
      setMsg(d.error || 'Eroare la creare cont');
    }
    setSaving(false);
  };

  const inp = s.input;
  const lbl = s.label;

  const DropZone = ({ label, sublabel, file, loading, onChange, accept }) => {
    const [drag, setDrag] = useState(false);
    return (
      <label
        onDragOver={e => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={e => { e.preventDefault(); setDrag(false); const f = e.dataTransfer.files[0]; if (f) onChange(f); }}
        style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          border: `2px dashed ${drag ? GOLD : file ? GREEN : '#D3D1C7'}`,
          borderRadius: '12px', padding: '20px 16px', cursor: 'pointer',
          background: drag ? '#FEF3DC' : file ? '#F0FFF4' : '#FAFAFA',
          transition: 'all .2s', textAlign: 'center', position: 'relative',
        }}>
        <input type="file" accept={accept || '.jpg,.jpeg,.png,.pdf'} style={{ display: 'none' }}
          onChange={e => { if (e.target.files[0]) onChange(e.target.files[0]); }} />
        {loading ? (
          <div style={{ fontSize: '13px', color: '#888' }}>⏳ Se procesează OCR...</div>
        ) : file ? (
          <>
            <div style={{ fontSize: '24px', marginBottom: '4px' }}>✅</div>
            <div style={{ fontSize: '12px', fontWeight: 700, color: '#15803D' }}>{file.name}</div>
            <div style={{ fontSize: '10px', color: '#888', marginTop: '2px' }}>Click pentru a înlocui</div>
          </>
        ) : (
          <>
            <div style={{ fontSize: '28px', marginBottom: '6px' }}>📂</div>
            <div style={{ fontSize: '13px', fontWeight: 700, color: DARK }}>{label}</div>
            <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>{sublabel}</div>
          </>
        )}
      </label>
    );
  };

  if (result) return (
    <Modal title="✅ Client adăugat cu succes!" onClose={onClose} maxWidth='460px'>
      <div style={{ background: '#DCFCE7', borderRadius: '10px', padding: '18px', marginBottom: '14px' }}>
        <div style={{ fontWeight: 700, color: '#15803D', fontSize: '14px', marginBottom: '10px' }}>🔑 Credențiale cont</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff', borderRadius: '8px', padding: '10px 14px', marginBottom: '6px' }}>
          <span style={{ fontSize: '12px', color: '#888' }}>Email</span>
          <span style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: '13px' }}>{result.user.email}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff', borderRadius: '8px', padding: '10px 14px' }}>
          <span style={{ fontSize: '12px', color: '#888' }}>Parolă</span>
          <span style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: '14px', color: NAVY }}>{result.password}</span>
        </div>
      </div>
      {result.vehicle && (
        <div style={{ background: '#E8EEF5', borderRadius: '10px', padding: '14px', marginBottom: '14px' }}>
          <div style={{ fontWeight: 700, color: NAVY, marginBottom: '6px' }}>🚗 Vehicul înregistrat</div>
          <div style={{ fontFamily: 'monospace', fontSize: '15px', color: GOLD, fontWeight: 700 }}>{result.vehicle.plate_number || result.vehicle.vin || '—'}</div>
          <div style={{ fontSize: '12px', color: '#555' }}>{result.vehicle.brand} {result.vehicle.model} {result.vehicle.year}</div>
        </div>
      )}
      <button onClick={() => { onCreated(); onClose(); }} style={{ ...s.btn, background: GOLD, color: DARK, width: '100%', padding: '12px' }}>Gata</button>
    </Modal>
  );

  return (
    <Modal title={`➕ Client rapid — Pasul ${step}/3`} onClose={onClose} maxWidth='560px'>
      {msg && <div style={{ background: '#FEE2E2', borderRadius: '8px', padding: '9px 12px', fontSize: '12px', color: '#B91C1C', marginBottom: '12px' }}>{msg}</div>}

      {/* Progress bar */}
      <div style={{ display: 'flex', gap: '4px', marginBottom: '20px' }}>
        {[1, 2, 3].map(n => (
          <div key={n} style={{ flex: 1, height: '4px', borderRadius: '4px', background: n <= step ? GOLD : '#E5E5E5', transition: 'background .3s' }} />
        ))}
      </div>

      {/* ── STEP 1 ─────────────────────────────────────────────────── */}
      {step === 1 && (
        <>
          {mode === 'upload' && (
            <>
              <div style={{ fontWeight: 700, fontSize: '13px', color: NAVY, marginBottom: '14px' }}>📄 Încarcă acte (OCR automat)</div>

              {/* Talon — obligatoriu */}
              <div style={{ marginBottom: '10px' }}>
                <label style={{ ...lbl, marginBottom: '6px' }}>Talon / Acte mașină *</label>
                <DropZone
                  label="Trage sau click pentru talon"
                  sublabel="JPG, PNG, PDF · datele mașinii se extrag automat"
                  file={talonFile}
                  loading={ocrLoading.talon}
                  onChange={handleTalonUpload}
                />
              </div>

              {/* OCR preview talon */}
              {talonOcr && !ocrLoading.talon && (
                <div style={{ background: '#F0FFF4', border: '0.5px solid #86EFAC', borderRadius: '10px', padding: '12px', marginBottom: '10px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                  {[['Nr. înmatriculare', talonOcr.plate_number], ['Marcă', talonOcr.brand], ['Model', talonOcr.model], ['An', talonOcr.year], ['VIN', talonOcr.vin]].filter(([, v]) => v).map(([k, v]) => (
                    <div key={k}>
                      <div style={{ fontSize: '9px', color: '#888', fontWeight: 700, textTransform: 'uppercase' }}>{k}</div>
                      <div style={{ fontSize: '12px', fontWeight: 700, color: '#15803D' }}>{v}</div>
                    </div>
                  ))}
                </div>
              )}

              {/* Buletin — opțional */}
              <div style={{ marginBottom: '14px' }}>
                <label style={{ ...lbl, marginBottom: '6px' }}>Buletin / CUI proprietar <span style={{ fontWeight: 400, color: '#aaa' }}>(opțional)</span></label>
                <DropZone
                  label="Trage sau click pentru buletin"
                  sublabel="JPG, PNG, PDF · datele proprietarului se extrag automat"
                  file={buletinFile}
                  loading={ocrLoading.buletin}
                  onChange={handleBuletinUpload}
                />
              </div>

              {/* OCR preview buletin */}
              {buletinOcr && !ocrLoading.buletin && (
                <div style={{ background: '#F0FFF4', border: '0.5px solid #86EFAC', borderRadius: '10px', padding: '12px', marginBottom: '10px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                  {[['Prenume', buletinOcr.first_name], ['Nume', buletinOcr.last_name], ['CNP', buletinOcr.cnp]].filter(([, v]) => v).map(([k, v]) => (
                    <div key={k}>
                      <div style={{ fontSize: '9px', color: '#888', fontWeight: 700, textTransform: 'uppercase' }}>{k}</div>
                      <div style={{ fontSize: '12px', fontWeight: 700, color: '#15803D' }}>{v}</div>
                    </div>
                  ))}
                </div>
              )}

              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '10px 0' }}>
                <div style={{ flex: 1, height: '1px', background: '#E5E5E5' }} />
                <span style={{ fontSize: '11px', color: '#aaa' }}>sau</span>
                <div style={{ flex: 1, height: '1px', background: '#E5E5E5' }} />
              </div>

              <button onClick={() => { setMode('manual'); setMsg(''); }}
                style={{ ...s.btn, background: 'transparent', border: '0.5px solid #D3D1C7', color: '#555', width: '100%', padding: '10px' }}>
                ✍️ Completez datele manual
              </button>
            </>
          )}

          {mode === 'manual' && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
                <button onClick={() => { setMode('upload'); setMsg(''); }}
                  style={{ ...s.btn, background: '#F4F4F4', color: '#555', border: '0.5px solid #D3D1C7', padding: '6px 12px', fontSize: '11px' }}>
                  ← Upload acte
                </button>
                <div style={{ fontWeight: 700, fontSize: '13px', color: NAVY }}>👤 Date client</div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '14px' }}>
                <div><label style={lbl}>Prenume *</label><input style={inp} value={client.first_name} onChange={e => setClient({ ...client, first_name: e.target.value })} /></div>
                <div><label style={lbl}>Nume *</label><input style={inp} value={client.last_name} onChange={e => setClient({ ...client, last_name: e.target.value })} /></div>
                <div style={{ gridColumn: '1/-1' }}><label style={lbl}>Email *</label><input style={inp} type="email" value={client.email} onChange={e => setClient({ ...client, email: e.target.value })} /></div>
                <div><label style={lbl}>Telefon</label><input style={inp} value={client.phone} onChange={e => setClient({ ...client, phone: e.target.value })} /></div>
                <div>
                  <label style={lbl}>Parolă *</label>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <input style={{ ...inp, fontFamily: 'monospace' }} value={client.password} onChange={e => setClient({ ...client, password: e.target.value })} />
                    <button onClick={() => setClient({ ...client, password: genPassword() })} style={{ ...s.btn, background: '#F4F4F4', color: '#555', border: '0.5px solid #D3D1C7', padding: '8px', flexShrink: 0 }} title="Generează">🔄</button>
                  </div>
                </div>
              </div>
            </>
          )}

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
            <button onClick={() => { setMsg(''); setStep(2); }}
              disabled={!canContinueStep1}
              style={{ ...s.btn, background: canContinueStep1 ? GOLD : '#E5E5E5', color: canContinueStep1 ? DARK : '#aaa', padding: '10px 24px', cursor: canContinueStep1 ? 'pointer' : 'not-allowed' }}>
              Continuă →
            </button>
          </div>
        </>
      )}

      {/* ── STEP 2 ─────────────────────────────────────────────────── */}
      {step === 2 && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
            <div style={{ fontWeight: 700, fontSize: '13px', color: NAVY }}>🚗 Date mașină</div>
            {talonOcr && <span style={{ fontSize: '10px', background: '#DCFCE7', color: '#15803D', padding: '2px 8px', borderRadius: '6px', fontWeight: 700 }}>✓ Pre-completat din OCR</span>}
          </div>

          {/* Auto-filled client info summary (from buletin OCR or manual) */}
          {(buletinOcr || client.first_name) && (
            <div style={{ background: '#E8EEF5', borderRadius: '8px', padding: '10px 14px', marginBottom: '14px', fontSize: '12px' }}>
              <span style={{ fontWeight: 700, color: NAVY }}>👤 Client: </span>
              {client.first_name} {client.last_name}
              {client.email && <span style={{ color: '#888' }}> · {client.email}</span>}
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '14px' }}>
            <div>
              <label style={lbl}>Nr. înmatriculare</label>
              <input style={{ ...inp, fontFamily: 'monospace', textTransform: 'uppercase' }} value={vehicle.plate_number} onChange={e => setVehicle({ ...vehicle, plate_number: e.target.value.toUpperCase() })} />
            </div>
            <div>
              <label style={lbl}>Serie șasiu (VIN)</label>
              <input style={{ ...inp, fontFamily: 'monospace', textTransform: 'uppercase' }} value={vehicle.vin} onChange={e => setVehicle({ ...vehicle, vin: e.target.value.toUpperCase() })} />
            </div>
            <div>
              <label style={lbl}>Marcă</label>
              <input style={inp} value={vehicle.brand} onChange={e => setVehicle({ ...vehicle, brand: e.target.value })} />
            </div>
            <div>
              <label style={lbl}>Model</label>
              <input style={inp} value={vehicle.model} onChange={e => setVehicle({ ...vehicle, model: e.target.value })} />
            </div>
            <div>
              <label style={lbl}>An fabricație</label>
              <input style={inp} type="number" value={vehicle.year} onChange={e => setVehicle({ ...vehicle, year: e.target.value })} placeholder="2018" />
            </div>
            <div>
              <label style={lbl}>Combustibil</label>
              <select style={inp} value={vehicle.fuel_type} onChange={e => setVehicle({ ...vehicle, fuel_type: e.target.value })}>
                <option value="">—</option>
                <option value="Benzina">Benzină</option>
                <option value="Motorina">Diesel</option>
                <option value="Hibrid">Hibrid</option>
                <option value="Electric">Electric</option>
                <option value="GPL">GPL</option>
              </select>
            </div>
            <div>
              <label style={lbl}>Cilindree (cc)</label>
              <input style={inp} type="number" value={vehicle.engine_cc} onChange={e => setVehicle({ ...vehicle, engine_cc: e.target.value })} />
            </div>
            <div>
              <label style={lbl}>Putere (kW)</label>
              <input style={inp} type="number" value={vehicle.power_kw} onChange={e => setVehicle({ ...vehicle, power_kw: e.target.value })} />
            </div>
          </div>

          {/* If manual mode, also collect client email/password here */}
          {mode === 'upload' && !client.email && (
            <div style={{ background: '#FEF3DC', borderRadius: '10px', padding: '14px', marginBottom: '14px' }}>
              <div style={{ fontWeight: 700, fontSize: '12px', color: '#D97706', marginBottom: '10px' }}>⚠️ Date cont client</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                <div style={{ gridColumn: '1/-1' }}><label style={lbl}>Email *</label><input style={inp} type="email" value={client.email} onChange={e => setClient({ ...client, email: e.target.value })} /></div>
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={lbl}>Parolă *</label>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <input style={{ ...inp, fontFamily: 'monospace' }} value={client.password} onChange={e => setClient({ ...client, password: e.target.value })} />
                    <button onClick={() => setClient({ ...client, password: genPassword() })} style={{ ...s.btn, background: '#F4F4F4', color: '#555', border: '0.5px solid #D3D1C7', padding: '8px', flexShrink: 0 }}>🔄</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div style={{ display: 'flex', gap: '8px', justifyContent: 'space-between' }}>
            <button onClick={() => setStep(1)} style={{ ...s.btn, background: '#F4F4F4', color: '#555', border: '0.5px solid #D3D1C7' }}>← Înapoi</button>
            <button onClick={() => { setMsg(''); setStep(3); }} style={{ ...s.btn, background: GOLD, color: DARK, padding: '10px 24px' }}>Continuă →</button>
          </div>
        </>
      )}

      {/* ── STEP 3 ─────────────────────────────────────────────────── */}
      {step === 3 && (
        <>
          <div style={{ fontWeight: 700, fontSize: '13px', color: NAVY, marginBottom: '12px' }}>⏰ Date expirări <span style={{ fontWeight: 400, color: '#888' }}>(opțional)</span></div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '14px' }}>
            {[['rca_expiry', '🛡️ RCA'], ['itp_expiry', '🔍 ITP'], ['casco_expiry', '🚗 CASCO'], ['rovinieta_expiry', '🛣️ Rovinieta']].map(([k, label]) => (
              <div key={k}><label style={lbl}>{label}</label><input type="date" style={inp} value={expiry[k]} onChange={e => setExpiry({ ...expiry, [k]: e.target.value })} /></div>
            ))}
          </div>

          {/* Summary */}
          <div style={{ background: '#F4F4F4', borderRadius: '10px', padding: '14px', marginBottom: '16px', fontSize: '12px' }}>
            <div style={{ fontWeight: 700, marginBottom: '8px', color: DARK }}>📋 Rezumat</div>
            <div style={{ marginBottom: '4px' }}>👤 {client.first_name} {client.last_name} · <span style={{ color: '#888' }}>{client.email}</span></div>
            {vehicle.plate_number && <div style={{ marginBottom: '4px' }}>🚗 <span style={{ fontFamily: 'monospace', fontWeight: 700, color: GOLD }}>{vehicle.plate_number}</span> — {vehicle.brand} {vehicle.model} {vehicle.year}</div>}
            {talonFile && <div style={{ color: '#15803D' }}>📄 Talon: {talonFile.name}</div>}
            {buletinFile && <div style={{ color: '#15803D' }}>🪪 Buletin: {buletinFile.name}</div>}
          </div>

          <div style={{ display: 'flex', gap: '8px', justifyContent: 'space-between' }}>
            <button onClick={() => setStep(2)} style={{ ...s.btn, background: '#F4F4F4', color: '#555', border: '0.5px solid #D3D1C7' }}>← Înapoi</button>
            <button onClick={createClient} disabled={saving}
              style={{ ...s.btn, background: saving ? '#E5E5E5' : GREEN, color: '#fff', padding: '10px 28px', cursor: saving ? 'not-allowed' : 'pointer' }}>
              {saving ? '⏳ Se creează...' : '✓ Creează cont'}
            </button>
          </div>
        </>
      )}
    </Modal>
  );
}

export default function AdminPage() {
  const [tab, setTab] = useState('dashboard');
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [services, setServices] = useState([]);
  const [requests, setRequests] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [msg, setMsg] = useState('');
  const [search, setSearch] = useState('');
  const [showAddCollab, setShowAddCollab] = useState(false);
  const [editCollab, setEditCollab] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [collabForm, setCollabForm] = useState({email:'',password:'',first_name:'',last_name:'',phone:'',company_name:'',categories:''});
  const [editForm, setEditForm] = useState({company_name:'',first_name:'',last_name:'',phone:'',categories:''});
  // New state
  const [editUser, setEditUser] = useState(null);
  const [userVehiclesModal, setUserVehiclesModal] = useState(null);
  const [vehicleDosarModal, setVehicleDosarModal] = useState(null);
  const [confirmDeleteUser, setConfirmDeleteUser] = useState(null);
  const [confirmPermDeleteUser, setConfirmPermDeleteUser] = useState(null);
  const [createClientWizard, setCreateClientWizard] = useState(false);
  const [nfcTags, setNfcTags] = useState([]);
  const [nfcGenCount, setNfcGenCount] = useState(3);
  const [nfcGenLabel, setNfcGenLabel] = useState();
  const [nfcGeneratedLinks, setNfcGeneratedLinks] = useState([]);
  const [nfcEditTag, setNfcEditTag] = useState(null);
  const [nfcEditForm, setNfcEditForm] = useState({});
  const [nfcAllUsers, setNfcAllUsers] = useState([]);
  const [replyModal, setReplyModal] = useState(null);
  const [replyForm, setReplyForm] = useState({ message: "", status: "active" });
  const [replySending, setReplySending] = useState(false);

  useEffect(() => { api('/admin/stats').then(d => d.users !== undefined && setStats(d)); }, []);

  useEffect(() => {
    if (tab==='users') loadUsers();
    if (tab==='vehicles') api('/admin/vehicles').then(d => d.vehicles && setVehicles(d.vehicles));
    if (tab==='collaborators') loadCollaborators();
    if (tab==='services') api('/admin/services').then(d => d.services && setServices(d.services));
    if (tab==='requests') api('/admin/requests').then(d => d.requests && setRequests(d.requests));
    if (tab==='alerts') api('/admin/alerts').then(d => d.alerts && setAlerts(d.alerts));
    if (tab==='nfc') loadNfcTags();
  }, [tab]);

  const loadUsers = () => api('/admin/users').then(d => d.users && setUsers(d.users));
  const loadCollaborators = () => api('/admin/collaborators').then(d => d.collaborators && setCollaborators(d.collaborators));

  const loadNfcTags = () => api('/admin/nfc').then(d => { if (d.tags) setNfcTags(d.tags); });
  const addCollaborator = async () => {
    if (!collabForm.email || !collabForm.password || !collabForm.company_name) { setMsg('Campuri obligatorii lipsa!'); return; }
    const data = await api('/admin/collaborators', {
      method:'POST',
      body: JSON.stringify({...collabForm, categories: collabForm.categories.split(',').map(c=>c.trim()).filter(Boolean)})
    });
    if (data.collaborator) { setMsg('✓ Colaborator adaugat!'); setShowAddCollab(false); setCollabForm({email:'',password:'',first_name:'',last_name:'',phone:'',company_name:'',categories:''}); loadCollaborators(); }
    else setMsg(data.error||'Eroare');
    setTimeout(()=>setMsg(''),3000);
  };

  const saveEditCollab = async () => {
    const data = await api(`/admin/collaborators/${editCollab.id}`, {
      method:'PUT',
      body: JSON.stringify({...editForm, categories: editForm.categories.split(',').map(c=>c.trim()).filter(Boolean)})
    });
    if (data.message) { setMsg('✓ Salvat!'); setEditCollab(null); loadCollaborators(); }
    else setMsg(data.error||'Eroare');
    setTimeout(()=>setMsg(''),3000);
  };

  const deleteCollab = async (id) => {
    const data = await api(`/admin/collaborators/${id}`, { method:'DELETE' });
    if (data.message) { setMsg('✓ Sters!'); setConfirmDelete(null); loadCollaborators(); }
    setTimeout(()=>setMsg(''),3000);
  };

  const toggleCollab = async (id, current) => {
    await api(`/admin/collaborators/${id}/toggle`, { method:'PATCH', body: JSON.stringify({is_active:!current}) });
    loadCollaborators();
  };

  const toggleUser = async (id, current) => {
    await api(`/admin/users/${id}/toggle`, { method:'PATCH', body: JSON.stringify({is_active:!current}) });
    loadUsers();
  };

  const deleteUser = async (id) => {
    await api(`/admin/users/${id}`, { method:'DELETE' });
    setConfirmDeleteUser(null);
    loadUsers();
  };

  const permanentDeleteUser = async (id) => {
    const d = await api(`/admin/users/${id}/permanent`, { method:'DELETE' });
    if (d.error) { setMsg(d.error); setConfirmPermDeleteUser(null); return; }
    setConfirmPermDeleteUser(null);
    loadUsers();
  };

  const toggleService = async (id, current) => {
    await api(`/admin/services/${id}/toggle`, { method:'PATCH', body: JSON.stringify({is_active:!current}) });
    api('/admin/services').then(d => d.services && setServices(d.services));
  };

  const TYPE_LABELS = {
    piese_auto:'🔩 Piese auto', service:'🔧 Service', anvelope:'🛞 Anvelope',
    itp:'🔍 ITP', rca_casco:'🛡️ RCA/CASCO', rovinieta:'🛣️ Rovinieta',
    inmatriculare:'📋 Inmatriculare', transport:'🚛 Transport'
  };

  const daysLeft = (date) => {
    if (!date) return null;
    return Math.ceil((new Date(date) - new Date()) / (1000*60*60*24));
  };

  const tabs = [
    {id:'dashboard',icon:'📊',label:'Dashboard'},
    {id:'users',icon:'👤',label:'Utilizatori'},
    {id:'vehicles',icon:'🚗',label:'Masini'},
    {id:'collaborators',icon:'🔧',label:'Colaboratori'},
    {id:'services',icon:'⚙️',label:'Servicii'},
    {id:'requests',icon:'💬',label:'Solicitari'},
    {id:'alerts',icon:'🔔',label:'Alerte'},
    {id:'nfc',icon:'🏷️',label:'NFC'},
  ];

  const filteredUsers = users.filter(u =>
    !search || u.email?.toLowerCase().includes(search.toLowerCase()) ||
    u.first_name?.toLowerCase().includes(search.toLowerCase()) ||
    u.last_name?.toLowerCase().includes(search.toLowerCase())
  );

  const filteredVehicles = vehicles.filter(v =>
    !search || v.plate_number?.toLowerCase().includes(search.toLowerCase()) ||
    v.brand?.toLowerCase().includes(search.toLowerCase()) ||
    v.email?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      {/* Modals */}
      {confirmDelete && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div style={{background:'#fff',borderRadius:'14px',padding:'28px',maxWidth:'360px',width:'90%',textAlign:'center'}}>
            <div style={{fontSize:'36px',marginBottom:'12px'}}>⚠️</div>
            <div style={{fontWeight:800,fontSize:'16px',marginBottom:'8px'}}>Confirmi stergerea?</div>
            <div style={{fontSize:'13px',color:'#555',marginBottom:'20px'}}>{confirmDelete.company_name} va fi dezactivat.</div>
            <div style={{display:'flex',gap:'10px',justifyContent:'center'}}>
              <button onClick={()=>deleteCollab(confirmDelete.id)} style={{...s.btn,background:RED,color:'#fff',padding:'10px 20px'}}>Sterge</button>
              <button onClick={()=>setConfirmDelete(null)} style={{...s.btn,background:'#F4F4F4',color:'#555',border:'0.5px solid #D3D1C7',padding:'10px 20px'}}>Anuleaza</button>
            </div>
          </div>
        </div>
      )}
      {confirmDeleteUser && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div style={{background:'#fff',borderRadius:'14px',padding:'28px',maxWidth:'360px',width:'90%',textAlign:'center'}}>
            <div style={{fontSize:'36px',marginBottom:'12px'}}>⚠️</div>
            <div style={{fontWeight:800,fontSize:'16px',marginBottom:'8px'}}>Dezactivezi userul?</div>
            <div style={{fontSize:'13px',color:'#555',marginBottom:'20px'}}>{confirmDeleteUser.email}</div>
            <div style={{display:'flex',gap:'10px',justifyContent:'center'}}>
              <button onClick={()=>deleteUser(confirmDeleteUser.id)} style={{...s.btn,background:RED,color:'#fff',padding:'10px 20px'}}>Dezactivează</button>
              <button onClick={()=>setConfirmDeleteUser(null)} style={{...s.btn,background:'#F4F4F4',color:'#555',border:'0.5px solid #D3D1C7',padding:'10px 20px'}}>Anulează</button>
            </div>
          </div>
        </div>
      )}
      {confirmPermDeleteUser && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div style={{background:'#fff',borderRadius:'14px',padding:'28px',maxWidth:'400px',width:'90%',textAlign:'center'}}>
            <div style={{fontSize:'40px',marginBottom:'12px'}}>🗑️</div>
            <div style={{fontWeight:800,fontSize:'16px',marginBottom:'8px',color:RED}}>Ștergere PERMANENTĂ</div>
            <div style={{fontSize:'13px',color:'#555',marginBottom:'6px'}}>{confirmPermDeleteUser.email}</div>
            <div style={{background:'#FEE2E2',borderRadius:'8px',padding:'10px',fontSize:'12px',color:'#B91C1C',marginBottom:'20px'}}>
              ⚠️ Această acțiune este ireversibilă. Se vor șterge toate datele utilizatorului: mașini, documente, solicitări.
            </div>
            <div style={{display:'flex',gap:'10px',justifyContent:'center'}}>
              <button onClick={()=>permanentDeleteUser(confirmPermDeleteUser.id)} style={{...s.btn,background:RED,color:'#fff',padding:'10px 20px',fontSize:'13px'}}>🗑 Șterge definitiv</button>
              <button onClick={()=>setConfirmPermDeleteUser(null)} style={{...s.btn,background:'#F4F4F4',color:'#555',border:'0.5px solid #D3D1C7',padding:'10px 20px'}}>Anulează</button>
            </div>
          </div>
        </div>
      )}
      {editCollab && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999,padding:'20px'}}>
          <div style={{background:'#fff',borderRadius:'14px',padding:'28px',maxWidth:'500px',width:'100%'}}>
            <div style={{fontWeight:800,fontSize:'16px',marginBottom:'16px'}}>✏️ Editeaza colaborator</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'10px'}}>
              <div><label style={s.label}>Nume companie *</label><input style={s.input} value={editForm.company_name} onChange={e=>setEditForm({...editForm,company_name:e.target.value})}/></div>
              <div><label style={s.label}>Telefon</label><input style={s.input} value={editForm.phone} onChange={e=>setEditForm({...editForm,phone:e.target.value})}/></div>
              <div><label style={s.label}>Prenume</label><input style={s.input} value={editForm.first_name} onChange={e=>setEditForm({...editForm,first_name:e.target.value})}/></div>
              <div><label style={s.label}>Nume</label><input style={s.input} value={editForm.last_name} onChange={e=>setEditForm({...editForm,last_name:e.target.value})}/></div>
              <div style={{gridColumn:'1/-1'}}><label style={s.label}>Categorii (virgula)</label><input style={s.input} value={editForm.categories} onChange={e=>setEditForm({...editForm,categories:e.target.value})}/></div>
            </div>
            <div style={{display:'flex',gap:'8px'}}>
              <button onClick={saveEditCollab} style={{...s.btn,background:GOLD,color:DARK,padding:'10px 20px'}}>Salveaza</button>
              <button onClick={()=>setEditCollab(null)} style={{...s.btn,background:'#F4F4F4',color:'#555',border:'0.5px solid #D3D1C7',padding:'10px 20px'}}>Anuleaza</button>
            </div>
          </div>
        </div>
      )}
      {editUser && <EditUserModal user={editUser} onClose={()=>setEditUser(null)} onSaved={loadUsers}/>}
      {userVehiclesModal && <UserVehiclesModal user={userVehiclesModal} onClose={()=>setUserVehiclesModal(null)}/>}
      {vehicleDosarModal && <VehicleDosarModal vehicle={vehicleDosarModal} userId={vehicleDosarModal.user_id} onClose={()=>setVehicleDosarModal(null)}/>}
      {createClientWizard && <CreateClientWizard onClose={()=>setCreateClientWizard(false)} onCreated={loadUsers}/>}

      <div style={{fontSize:'20px',fontWeight:800,marginBottom:'14px'}}>👑 Panou Administrator</div>

      {msg && <div style={{background:msg.includes('✓')?'#DCFCE7':'#FEE2E2',borderRadius:'8px',padding:'10px',fontSize:'12px',color:msg.includes('✓')?'#15803D':'#B91C1C',marginBottom:'12px'}}>{msg}</div>}

      {/* Tabs */}
      <div style={{display:'flex',gap:'3px',background:DARK,padding:'4px',borderRadius:'12px',marginBottom:'14px',overflowX:'auto'}}>
        {tabs.map(t=>(
          <button key={t.id} onClick={()=>{setTab(t.id);setSearch('');}} style={{...s.btn,flex:1,background:tab===t.id?GOLD:'transparent',color:tab===t.id?DARK:'rgba(255,255,255,.5)',padding:'7px 8px',fontSize:'11px',whiteSpace:'nowrap',borderRadius:'8px'}}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {/* DASHBOARD */}
      {tab==='dashboard' && (
        <div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'10px',marginBottom:'14px'}}>
            <StatCard icon="👤" label="Clienti inregistrati" value={stats?.users||0} sub={`+${stats?.new_users_today||0} azi · +${stats?.new_users_week||0} saptamana`} color={NAVY}/>
            <StatCard icon="✅" label="Conturi active" value={stats?.active_users||0} color={GREEN}/>
            <StatCard icon="🚗" label="Masini in platforma" value={stats?.vehicles||0} color={GOLD}/>
            <StatCard icon="🔧" label="Colaboratori activi" value={stats?.collaborators||0} color={'#0891B2'}/>
            <StatCard icon="💬" label="Solicitari active" value={stats?.active_requests||0} sub={`${stats?.total_requests||0} total`} color={'#D97706'}/>
            <StatCard icon="📄" label="Documente generate" value={stats?.docs_generated||0} color={PURPLE}/>
          </div>
          <div style={s.card}>
            <div style={{fontWeight:700,marginBottom:'10px'}}>Actiuni rapide</div>
            <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
              <button onClick={()=>{setTab('users');setTimeout(()=>setCreateClientWizard(true),100);}} style={{...s.btn,background:GREEN,color:'#fff'}}>➕ Client rapid</button>
              <button onClick={()=>setTab('collaborators')} style={{...s.btn,background:GOLD,color:DARK}}>+ Colaborator nou</button>
              <button onClick={()=>setTab('services')} style={{...s.btn,background:NAVY,color:'#fff'}}>⚙️ Servicii</button>
              <button onClick={()=>setTab('alerts')} style={{...s.btn,background:RED,color:'#fff'}}>🔔 Alerte expirari</button>
              <button onClick={()=>setTab('requests')} style={{...s.btn,background:'#F4F4F4',color:'#555',border:'0.5px solid #D3D1C7'}}>💬 Solicitari</button>
            </div>
          </div>
        </div>
      )}

      {/* UTILIZATORI */}
      {tab==='users' && (
        <div>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px',gap:'10px',flexWrap:'wrap'}}>
            <div style={{fontWeight:700,fontSize:'15px'}}>👤 Utilizatori ({filteredUsers.length})</div>
            <div style={{display:'flex',gap:'8px'}}>
              <input style={{...s.input,maxWidth:'220px'}} placeholder="Cauta..." value={search} onChange={e=>setSearch(e.target.value)}/>
              <button onClick={()=>setCreateClientWizard(true)} style={{...s.btn,background:GREEN,color:'#fff',whiteSpace:'nowrap'}}>➕ Client rapid</button>
            </div>
          </div>
          <div style={{background:'#fff',borderRadius:'12px',overflow:'hidden',border:'0.5px solid #D3D1C7'}}>
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead>
                <tr>
                  <th style={s.th}>Utilizator</th>
                  <th style={s.th}>Contact</th>
                  <th style={s.th}>Mașini</th>
                  <th style={s.th}>Înregistrat</th>
                  <th style={s.th}>Status</th>
                  <th style={s.th}>Acțiuni</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.filter(u=>u.role==='owner').map(u=>(
                  <tr key={u.id} style={{background:u.is_active?'#fff':'#FEF2F2'}}>
                    <td style={s.td}>
                      <div style={{fontWeight:600}}>{u.first_name} {u.last_name}</div>
                      <div style={{fontSize:'10px',color:'#888',fontFamily:'monospace'}}>{u.email}</div>
                    </td>
                    <td style={s.td}><div style={{fontSize:'11px'}}>{u.phone||'—'}</div></td>
                    <td style={s.td}><span style={{background:'#E8EEF5',color:NAVY,padding:'2px 8px',borderRadius:'6px',fontSize:'11px',fontWeight:700}}>{u.vehicle_count}</span></td>
                    <td style={s.td}><div style={{fontSize:'11px',color:'#888'}}>{new Date(u.created_at).toLocaleDateString('ro-RO')}</div></td>
                    <td style={s.td}><Toggle checked={u.is_active} onChange={()=>toggleUser(u.id,u.is_active)}/></td>
                    <td style={s.td}>
                      <div style={{display:'flex',gap:'4px',flexWrap:'wrap'}}>
                        <button onClick={()=>setEditUser(u)} style={{...s.btn,background:'#E8EEF5',color:NAVY,padding:'5px 8px',fontSize:'11px'}}>✏️</button>
                        <button onClick={()=>setUserVehiclesModal(u)} style={{...s.btn,background:'#FEF3DC',color:GOLD,padding:'5px 8px',fontSize:'11px'}}>🚗</button>
                        <button onClick={()=>setConfirmDeleteUser(u)} style={{...s.btn,background:'#FEF3DC',color:'#D97706',padding:'5px 8px',fontSize:'11px'}} title='Dezactivează'>🔕</button>
                        <button onClick={()=>setConfirmPermDeleteUser(u)} style={{...s.btn,background:'#FEE2E2',color:RED,padding:'5px 8px',fontSize:'11px'}} title='Șterge definitiv'>🗑</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* MASINI */}
      {tab==='vehicles' && (
        <div>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px',gap:'10px'}}>
            <div style={{fontWeight:700,fontSize:'15px'}}>🚗 Masini ({filteredVehicles.length})</div>
            <input style={{...s.input,maxWidth:'250px'}} placeholder="Cauta dupa nr, marca, email..." value={search} onChange={e=>setSearch(e.target.value)}/>
          </div>
          <div style={{background:'#fff',borderRadius:'12px',overflow:'hidden',border:'0.5px solid #D3D1C7'}}>
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead>
                <tr>
                  <th style={s.th}>Vehicul</th>
                  <th style={s.th}>Proprietar</th>
                  <th style={s.th}>VIN</th>
                  <th style={s.th}>Documente</th>
                  <th style={s.th}>Adaugat</th>
                  <th style={s.th}>Dosar</th>
                </tr>
              </thead>
              <tbody>
                {filteredVehicles.map(v=>(
                  <tr key={v.id}>
                    <td style={s.td}>
                      <div style={{fontFamily:'monospace',fontWeight:700,color:GOLD,fontSize:'13px'}}>{v.plate_number||v.vin||'—'}</div>
                      <div style={{fontSize:'11px',color:'#555'}}>{v.brand} {v.model} {v.year}</div>
                    </td>
                    <td style={s.td}>
                      <div style={{fontWeight:600,fontSize:'12px'}}>{v.first_name} {v.last_name}</div>
                      <div style={{fontSize:'10px',color:'#888'}}>{v.email}</div>
                    </td>
                    <td style={s.td}><div style={{fontFamily:'monospace',fontSize:'10px',color:'#888'}}>{v.vin||'—'}</div></td>
                    <td style={s.td}><span style={{background:'#DCFCE7',color:'#15803D',padding:'2px 8px',borderRadius:'6px',fontSize:'11px',fontWeight:700}}>{v.doc_count} doc</span></td>
                    <td style={s.td}><div style={{fontSize:'11px',color:'#888'}}>{new Date(v.created_at).toLocaleDateString('ro-RO')}</div></td>
                    <td style={s.td}>
                      <button onClick={()=>setVehicleDosarModal(v)} style={{...s.btn,background:'#E8EEF5',color:NAVY,padding:'6px 10px',fontSize:'11px'}}>📂 Dosar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* COLABORATORI */}
      {tab==='collaborators' && (
        <div>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
            <div style={{fontWeight:700,fontSize:'15px'}}>🔧 Colaboratori ({collaborators.length})</div>
            <button onClick={()=>setShowAddCollab(!showAddCollab)} style={{...s.btn,background:GOLD,color:DARK}}>+ Adauga colaborator</button>
          </div>

          {showAddCollab && (
            <div style={{...s.card,background:'#FEF3DC',border:'1.5px solid '+GOLD,marginBottom:'14px'}}>
              <div style={{fontWeight:700,marginBottom:'12px'}}>Colaborator nou</div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'10px'}}>
                <div><label style={s.label}>Nume companie *</label><input style={s.input} value={collabForm.company_name} onChange={e=>setCollabForm({...collabForm,company_name:e.target.value})} placeholder="Auto Parts SRL"/></div>
                <div><label style={s.label}>Email *</label><input style={s.input} value={collabForm.email} onChange={e=>setCollabForm({...collabForm,email:e.target.value})} placeholder="email@firma.ro"/></div>
                <div><label style={s.label}>Parola *</label><input style={s.input} type="password" value={collabForm.password} onChange={e=>setCollabForm({...collabForm,password:e.target.value})}/></div>
                <div><label style={s.label}>Telefon</label><input style={s.input} value={collabForm.phone} onChange={e=>setCollabForm({...collabForm,phone:e.target.value})} placeholder="07xx xxx xxx"/></div>
                <div><label style={s.label}>Prenume</label><input style={s.input} value={collabForm.first_name} onChange={e=>setCollabForm({...collabForm,first_name:e.target.value})}/></div>
                <div><label style={s.label}>Nume</label><input style={s.input} value={collabForm.last_name} onChange={e=>setCollabForm({...collabForm,last_name:e.target.value})}/></div>
                <div style={{gridColumn:'1/-1'}}><label style={s.label}>Categorii (separate prin virgula)</label><input style={s.input} value={collabForm.categories} onChange={e=>setCollabForm({...collabForm,categories:e.target.value})} placeholder="piese_auto, service, anvelope"/></div>
              </div>
              <div style={{display:'flex',gap:'8px'}}>
                <button onClick={addCollaborator} style={{...s.btn,background:GOLD,color:DARK}}>Salveaza</button>
                <button onClick={()=>setShowAddCollab(false)} style={{...s.btn,background:'transparent',border:'0.5px solid #D3D1C7',color:'#555'}}>Anuleaza</button>
              </div>
            </div>
          )}

          {collaborators.map(c=>(
            <div key={c.id} style={{...s.card,borderLeft:`4px solid ${c.is_active?GREEN:'#D3D1C7'}`,opacity:c.is_active?1:0.6}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div>
                  <div style={{fontWeight:700,fontSize:'14px'}}>{c.company_name}</div>
                  <div style={{fontSize:'11px',color:'#888',marginTop:'2px'}}>{c.email} {c.phone?`· ${c.phone}`:''}</div>
                  <div style={{fontSize:'10px',color:'#aaa',marginTop:'2px'}}>{(c.categories||[]).join(', ')||'Fara categorii'} · {new Date(c.created_at).toLocaleDateString('ro-RO')}</div>
                </div>
                <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                  <Toggle checked={c.is_active} onChange={()=>toggleCollab(c.id,c.is_active)}/>
                  <button onClick={()=>{setEditCollab(c);setEditForm({company_name:c.company_name||'',first_name:c.first_name||'',last_name:c.last_name||'',phone:c.phone||'',categories:(c.categories||[]).join(', ')});}} style={{...s.btn,background:'#E8EEF5',color:NAVY}}>✏️ Edit</button>
                  <button onClick={()=>setConfirmDelete(c)} style={{...s.btn,background:'#FEE2E2',color:RED}}>🗑</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* SERVICII */}
      {tab==='services' && (
        <div>
          <div style={{fontWeight:700,fontSize:'15px',marginBottom:'12px'}}>⚙️ Servicii platforma</div>
          {services.map(svc=>(
            <div key={svc.id} style={{...s.card,display:'flex',justifyContent:'space-between',alignItems:'center',borderLeft:`4px solid ${svc.is_active?GREEN:'#D3D1C7'}`,opacity:svc.is_active?1:0.6}}>
              <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
                <div style={{width:'36px',height:'36px',borderRadius:'8px',background:'#F4F4F4',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'16px'}}>{svc.icon}</div>
                <div>
                  <div style={{fontWeight:700,fontSize:'13px'}}>{svc.name}</div>
                  <div style={{fontSize:'11px',color:'#888'}}>{svc.description}</div>
                </div>
              </div>
              <Toggle checked={svc.is_active} onChange={()=>toggleService(svc.id,svc.is_active)}/>
            </div>
          ))}
        </div>
      )}

      {/* SOLICITARI */}
      {tab==='requests' && (
        <div>
          {replyModal && (
            <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.55)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999,padding:'16px'}}>
              <div style={{background:'#fff',borderRadius:'14px',maxWidth:'520px',width:'100%',maxHeight:'90vh',overflowY:'auto'}}>
                <div style={{background:NAVY,padding:'14px 20px',display:'flex',alignItems:'center',justifyContent:'space-between',borderRadius:'14px 14px 0 0'}}>
                  <div style={{color:'#fff',fontWeight:800,fontSize:'15px'}}>✉️ Răspunde la solicitare</div>
                  <button onClick={()=>setReplyModal(null)} style={{background:'rgba(255,255,255,.15)',border:'none',borderRadius:'8px',padding:'5px 10px',color:'#fff',cursor:'pointer',fontSize:'14px'}}>✕</button>
                </div>
                <div style={{padding:'20px'}}>
                  <div style={{background:'#F4F4F4',borderRadius:'10px',padding:'12px 14px',marginBottom:'16px'}}>
                    <div style={{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'8px'}}>Detalii solicitare</div>
                    <div style={{fontSize:'13px',fontWeight:700,color:DARK,marginBottom:'4px'}}>{TYPE_LABELS[replyModal.request_type]||replyModal.request_type}</div>
                    <div style={{fontSize:'12px',color:'#555'}}>{replyModal.first_name} {replyModal.last_name} · <span style={{color:NAVY}}>{replyModal.email}</span></div>
                    {replyModal.plate_number && <div style={{fontSize:'11px',color:NAVY,fontFamily:'monospace',marginTop:'3px'}}>{replyModal.plate_number} · {replyModal.brand} {replyModal.model}</div>}
                    <div style={{fontSize:'11px',color:'#888',marginTop:'4px'}}>{new Date(replyModal.created_at).toLocaleDateString('ro-RO')}</div>
                    {replyModal.description && <div style={{fontSize:'11px',color:'#555',marginTop:'4px',borderTop:'0.5px solid #E5E5E5',paddingTop:'6px'}}>{replyModal.description.substring(0,150)}</div>}
                  </div>
                  <div style={{marginBottom:'14px'}}>
                    <label style={s.label}>Status solicitare</label>
                    <select style={{...s.input}} value={replyForm.status} onChange={e=>setReplyForm({...replyForm,status:e.target.value})}>
                      <option value="active">🟡 Activ</option>
                      <option value="in_progress">🔵 În lucru</option>
                      <option value="accepted">🟢 Acceptat</option>
                      <option value="closed">⚫ Închis</option>
                    </select>
                  </div>
                  <div style={{marginBottom:'16px'}}>
                    <label style={s.label}>Mesaj răspuns *</label>
                    <textarea
                      style={{...s.input,height:'130px',resize:'vertical',lineHeight:1.6}}
                      placeholder="Scrieți răspunsul pentru client..."
                      value={replyForm.message}
                      onChange={e=>setReplyForm({...replyForm,message:e.target.value})}
                    />
                  </div>
                  <div style={{display:'flex',gap:'10px'}}>
                    <button
                      disabled={replySending||!replyForm.message.trim()}
                      onClick={async()=>{
                        if(!replyForm.message.trim()){setMsg('Mesajul este obligatoriu.');return;}
                        setReplySending(true);
                        const d=await api('/admin/requests/'+replyModal.id+'/reply',{method:'POST',body:JSON.stringify({message:replyForm.message,status:replyForm.status})});
                        setReplySending(false);
                        if(d.message){
                          setMsg(d.message);
                          setReplyModal(null);
                          api('/admin/requests').then(r=>r.requests&&setRequests(r.requests));
                        }else{setMsg(d.error||'Eroare la trimitere');}
                        setTimeout(()=>setMsg(''),5000);
                      }}
                      style={{...s.btn,background:replySending||!replyForm.message.trim()?'#D3D1C7':GREEN,color:'#fff',flex:1,cursor:replySending?'not-allowed':'pointer'}}
                    >
                      {replySending?'⏳ Se trimite...':'📤 Trimite răspuns'}
                    </button>
                    <button onClick={()=>setReplyModal(null)} style={{...s.btn,background:'#F4F4F4',color:'#555',border:'0.5px solid #D3D1C7',padding:'8px 20px'}}>Anulează</button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div style={{fontWeight:700,fontSize:'15px',marginBottom:'12px'}}>💬 Solicitări ({requests.length})</div>
          {requests.map(req=>{
            const statusColor={active:GOLD,in_progress:NAVY,accepted:GREEN,closed:'#888'}[req.status]||'#888';
            const statusBg={active:'#FEF3DC',in_progress:'#DBEAFE',accepted:'#DCFCE7',closed:'#F4F4F4'}[req.status]||'#F4F4F4';
            const statusLabel={active:'🟡 Activ',in_progress:'🔵 În lucru',accepted:'🟢 Acceptat',closed:'⚫ Închis'}[req.status]||req.status;
            const borderColor={active:GOLD,in_progress:NAVY,accepted:GREEN,closed:'#D3D1C7'}[req.status]||'#D3D1C7';
            return (
              <div key={req.id} style={{...s.card,borderLeft:`4px solid ${borderColor}`,marginBottom:'10px'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'start',marginBottom:'8px',gap:'10px'}}>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:700,fontSize:'13px',marginBottom:'3px'}}>{TYPE_LABELS[req.request_type]||req.request_type}</div>
                    <div style={{fontSize:'11px',color:'#888'}}>{req.first_name} {req.last_name} · {req.email}</div>
                    {req.plate_number && <div style={{fontSize:'11px',color:NAVY,fontFamily:'monospace',marginTop:'2px'}}>{req.plate_number} · {req.brand} {req.model}</div>}
                  </div>
                  <div style={{textAlign:'right',flexShrink:0}}>
                    <span style={{background:statusBg,color:statusColor,fontSize:'10px',fontWeight:700,padding:'3px 9px',borderRadius:'7px',display:'inline-block'}}>{statusLabel}</span>
                    <div style={{fontSize:'10px',color:'#aaa',marginTop:'3px'}}>{req.offer_count} oferte</div>
                  </div>
                </div>
                <div style={{fontSize:'11px',color:'#555',marginBottom:'8px',lineHeight:1.5}}>{req.description?.substring(0,120)}{req.description?.length>120?'...':''}</div>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:'8px'}}>
                  <div style={{fontSize:'10px',color:'#aaa'}}>{new Date(req.created_at).toLocaleDateString('ro-RO')} · 📍 {req.location}</div>
                  <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                    {req.replied_at && <span style={{fontSize:'10px',color:GREEN,fontWeight:700}}>✉️ {new Date(req.replied_at).toLocaleDateString('ro-RO')}</span>}
                    <button
                      onClick={()=>{setReplyModal(req);setReplyForm({message:req.admin_reply||'',status:req.status||'active'});}}
                      style={{...s.btn,background:req.replied_at?'#DCFCE7':NAVY,color:req.replied_at?'#15803D':'#fff',padding:'5px 12px',fontSize:'11px'}}
                    >
                      {req.replied_at?'✉️ Modifică':'✉️ Răspunde'}
                    </button>
                  </div>
                </div>
                {req.admin_reply && (
                  <div style={{marginTop:'8px',background:'#F0FFF4',border:'0.5px solid #86EFAC',borderRadius:'8px',padding:'8px 12px',fontSize:'11px',color:'#15803D'}}>
                    <span style={{fontWeight:700}}>Răspuns: </span>{req.admin_reply.substring(0,100)}{req.admin_reply.length>100?'...':''}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* ALERTE */}
      {tab==='alerts' && (
        <div>
          <div style={{fontWeight:700,fontSize:'15px',marginBottom:'6px'}}>🔔 Alerte expirari ({alerts.length})</div>
          <div style={{fontSize:'12px',color:'#888',marginBottom:'12px'}}>Vehicule cu documente care expira in urmatoarele 30 de zile</div>
          {alerts.length === 0 ? (
            <div style={{...s.card,textAlign:'center',padding:'32px'}}>
              <div style={{fontSize:'40px',marginBottom:'10px'}}>✅</div>
              <div style={{fontWeight:700}}>Nu sunt alerte active</div>
              <div style={{fontSize:'12px',color:'#888',marginTop:'4px'}}>Toate documentele sunt valabile</div>
            </div>
          ) : alerts.map((a,i)=>{
            const docs = [
              {label:'RCA', date:a.rca_expiry, days:daysLeft(a.rca_expiry)},
              {label:'ITP', date:a.itp_expiry, days:daysLeft(a.itp_expiry)},
              {label:'CASCO', date:a.casco_expiry, days:daysLeft(a.casco_expiry)},
              {label:'Rovinieta', date:a.rovinieta_expiry, days:daysLeft(a.rovinieta_expiry)},
            ].filter(d=>d.days!==null && d.days<=30);
            return (
              <div key={i} style={{...s.card,borderLeft:`4px solid ${RED}`}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'start',marginBottom:'8px'}}>
                  <div>
                    <div style={{fontWeight:700,fontFamily:'monospace',fontSize:'14px',color:GOLD}}>{a.plate_number}</div>
                    <div style={{fontSize:'12px',color:'#555'}}>{a.brand} {a.model}</div>
                    <div style={{fontSize:'11px',color:'#888'}}>{a.first_name} {a.last_name} · {a.email}</div>
                  </div>
                </div>
                <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
                  {docs.map(d=>(
                    <span key={d.label} style={{background:d.days<=7?'#FEE2E2':'#FEF3DC',color:d.days<=7?RED:GOLD,fontSize:'11px',fontWeight:700,padding:'3px 10px',borderRadius:'7px'}}>
                      {d.label}: {d.days<=0?'EXPIRAT':d.days+' zile'}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {/* NFC TAG-URI */}
      {tab==='nfc' && (
        <div>
          {/* Modal editare tag */}
          {nfcEditTag && (
            <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999,padding:'16px'}}>
              <div style={{background:'#fff',borderRadius:'14px',maxWidth:'480px',width:'100%',overflow:'hidden'}}>
                <div style={{background:NAVY,padding:'14px 20px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                  <div style={{color:'#fff',fontWeight:800,fontSize:'14px'}}>✏️ Editează tag NFC</div>
                  <button onClick={()=>setNfcEditTag(null)} style={{background:'rgba(255,255,255,.15)',border:'none',borderRadius:'7px',padding:'4px 9px',color:'#fff',cursor:'pointer'}}>✕</button>
                </div>
                <div style={{padding:'20px'}}>
                  <div style={{marginBottom:'12px'}}>
                    <label style={s.label}>Label / Etichetă</label>
                    <input style={s.input} value={nfcEditForm.label||''} onChange={e=>setNfcEditForm({...nfcEditForm,label:e.target.value})} placeholder="ex: Tag client Popescu"/>
                  </div>
                  <div style={{marginBottom:'12px'}}>
                    <label style={s.label}>Destinație</label>
                    <select style={{...s.input}} value={nfcEditForm.destination||'setup'} onChange={e=>setNfcEditForm({...nfcEditForm,destination:e.target.value})}>
                      <option value="setup">⚙️ Setup (neactivat)</option>
                      <option value="account">📱 Cont principal</option>
                      <option value="vehicle">🚗 Mașină specifică</option>
                    </select>
                  </div>
                  <div style={{marginBottom:'12px'}}>
                    <label style={s.label}>User ID (UUID)</label>
                    <input style={s.input} value={nfcEditForm.user_id||''} onChange={e=>setNfcEditForm({...nfcEditForm,user_id:e.target.value})} placeholder="UUID user (optional)"/>
                  </div>
                  <div style={{marginBottom:'16px'}}>
                    <label style={s.label}>Vehicle ID (UUID)</label>
                    <input style={s.input} value={nfcEditForm.vehicle_id||''} onChange={e=>setNfcEditForm({...nfcEditForm,vehicle_id:e.target.value})} placeholder="UUID mașină (optional)"/>
                  </div>
                  <button onClick={async()=>{
                    const d = await api('/admin/nfc/'+nfcEditTag.id, {method:'PATCH',body:JSON.stringify(nfcEditForm)});
                    if (d.tag) { setMsg('✓ Tag actualizat.'); setNfcEditTag(null); loadNfcTags(); setTimeout(()=>setMsg(''),3000); }
                    else setMsg(d.error||'Eroare');
                  }} style={{...s.btn,background:GOLD,color:DARK,width:'100%'}}>Salvează</button>
                </div>
              </div>
            </div>
          )}

          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px',gap:'10px',flexWrap:'wrap'}}>
            <div style={{fontWeight:700,fontSize:'15px'}}>🏷️ Tag-uri NFC ({nfcTags.length})</div>
          </div>

          {/* Generator tag-uri */}
          <div style={{...s.card,marginBottom:'14px'}}>
            <div style={{fontWeight:700,fontSize:'13px',marginBottom:'10px'}}>➕ Generează tag-uri noi</div>
            <div style={{display:'flex',gap:'8px',alignItems:'center',flexWrap:'wrap'}}>
              <div style={{flex:'0 0 80px'}}>
                <label style={s.label}>Număr</label>
                <input type="number" min="1" max="50" style={{...s.input}} value={nfcGenCount} onChange={e=>setNfcGenCount(parseInt(e.target.value)||1)}/>
              </div>
              <div style={{flex:1,minWidth:'160px'}}>
                <label style={s.label}>Label (opțional)</label>
                <input style={s.input} value={nfcGenLabel} onChange={e=>setNfcGenLabel(e.target.value)} placeholder="ex: Lot mai 2026"/>
              </div>
              <div style={{flex:'0 0 auto',alignSelf:'flex-end'}}>
                <button onClick={async()=>{
                  const d = await api('/admin/nfc/generate',{method:'POST',body:JSON.stringify({count:nfcGenCount,label:nfcGenLabel||null})});
                  if (d.tags) {
                    setNfcGeneratedLinks(d.tags.map(t=>({token:t.token,url:'https://dosarmasina.ro/nfc/'+t.token})));
                    loadNfcTags();
                    setMsg('✓ '+d.message);
                    setTimeout(()=>setMsg(''),4000);
                  } else setMsg(d.error||'Eroare');
                }} style={{...s.btn,background:GREEN,color:'#fff'}}>Generează</button>
              </div>
            </div>

            {nfcGeneratedLinks.length > 0 && (
              <div style={{marginTop:'14px'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'8px'}}>
                  <div style={{fontWeight:700,fontSize:'12px'}}>🔗 Link-uri generate ({nfcGeneratedLinks.length})</div>
                  <div style={{display:'flex',gap:'6px'}}>
                    <button onClick={()=>{
                      navigator.clipboard.writeText(nfcGeneratedLinks.map(l=>l.url).join('\n'));
                      setMsg('✓ Link-uri copiate!');setTimeout(()=>setMsg(''),2000);
                    }} style={{...s.btn,background:NAVY,color:'#fff',padding:'5px 12px',fontSize:'11px'}}>📋 Copiază toate</button>
                    <button onClick={()=>{
                      const win = window.open('','_blank');
                      win.document.write('<html><head><title>Tag-uri NFC</title><style>body{font-family:Arial;padding:20px}h2{color:#1E3A5F}table{width:100%;border-collapse:collapse}td,th{border:1px solid #ddd;padding:8px;font-size:12px}th{background:#f4f4f4}</style></head><body><h2>Tag-uri NFC — dosarmasina.ro</h2><table><tr><th>Nr.</th><th>Token</th><th>Link NFC</th></tr>'+nfcGeneratedLinks.map((l,i)=>'<tr><td>'+(i+1)+'</td><td style="font-family:monospace">'+l.token+'</td><td>'+l.url+'</td></tr>').join('')+'</table><script>window.onload=()=>setTimeout(()=>window.print(),500)</script></body></html>');
                      win.document.close();
                    }} style={{...s.btn,background:'#F4F4F4',color:'#555',border:'0.5px solid #D3D1C7',padding:'5px 12px',fontSize:'11px'}}>🖨 Printează</button>
                    <button onClick={()=>setNfcGeneratedLinks([])} style={{...s.btn,background:'#FEE2E2',color:RED,padding:'5px 12px',fontSize:'11px'}}>✕</button>
                  </div>
                </div>
                <div style={{background:'#F4F4F4',borderRadius:'10px',padding:'10px',maxHeight:'200px',overflowY:'auto'}}>
                  {nfcGeneratedLinks.map((l,i)=>(
                    <div key={i} style={{fontFamily:'monospace',fontSize:'11px',padding:'4px 0',borderBottom:'0.5px solid #E5E5E5',display:'flex',justifyContent:'space-between',gap:'10px'}}>
                      <span style={{color:'#888'}}>{i+1}.</span>
                      <span style={{color:NAVY,flex:1}}>{l.url}</span>
                      <button onClick={()=>{navigator.clipboard.writeText(l.url);}} style={{background:'transparent',border:'none',cursor:'pointer',fontSize:'11px',color:'#888'}}>📋</button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Tabel tag-uri */}
          <div style={{background:'#fff',borderRadius:'12px',overflow:'hidden',border:'0.5px solid #D3D1C7'}}>
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead>
                <tr>
                  <th style={s.th}>Token</th>
                  <th style={s.th}>User asociat</th>
                  <th style={s.th}>Destinație</th>
                  <th style={s.th}>Ultima scanare</th>
                  <th style={s.th}>Scanări</th>
                  <th style={s.th}>Status</th>
                  <th style={s.th}>Acțiuni</th>
                </tr>
              </thead>
              <tbody>
                {nfcTags.length === 0 ? (
                  <tr><td colSpan={7} style={{...s.td,textAlign:'center',color:'#888',padding:'32px'}}>Nu există tag-uri NFC. Generează mai sus.</td></tr>
                ) : nfcTags.map(tag=>(
                  <tr key={tag.id} style={{background:tag.is_active?'#fff':'#F9F9F9'}}>
                    <td style={s.td}>
                      <div style={{fontFamily:'monospace',fontSize:'12px',fontWeight:700,color:DARK}}>{tag.token.substring(0,8)}…</div>
                      {tag.label && <div style={{fontSize:'10px',color:'#888'}}>{tag.label}</div>}
                    </td>
                    <td style={s.td}>
                      {tag.user_email ? (
                        <div>
                          <div style={{fontSize:'11px',fontWeight:600}}>{tag.user_first_name} {tag.user_last_name}</div>
                          <div style={{fontSize:'10px',color:'#888'}}>{tag.user_email}</div>
                        </div>
                      ) : <span style={{color:'#aaa',fontSize:'11px'}}>—</span>}
                    </td>
                    <td style={s.td}>
                      <span style={{background:tag.destination==='setup'?'#F4F4F4':tag.destination==='account'?'#E8EEF5':'#DCFCE7',color:tag.destination==='setup'?'#888':tag.destination==='account'?NAVY:'#15803D',padding:'2px 8px',borderRadius:'6px',fontSize:'11px',fontWeight:600}}>
                        {tag.destination==='setup'?'⚙️ Neactivat':tag.destination==='account'?'📱 Cont':tag.destination==='vehicle'?`🚗 ${tag.vehicle_plate||'Mașină'}`:tag.destination}
                      </span>
                    </td>
                    <td style={s.td}><div style={{fontSize:'11px',color:'#888'}}>{tag.last_scanned_at?new Date(tag.last_scanned_at).toLocaleDateString('ro-RO'):'—'}</div></td>
                    <td style={s.td}><span style={{background:'#F4F4F4',borderRadius:'6px',padding:'2px 8px',fontSize:'11px',fontWeight:700}}>{tag.scan_count}</span></td>
                    <td style={s.td}><span style={{color:tag.is_active?GREEN:RED,fontSize:'11px',fontWeight:700}}>{tag.is_active?'Activ':'Inactiv'}</span></td>
                    <td style={s.td}>
                      <div style={{display:'flex',gap:'4px',flexWrap:'wrap'}}>
                        <button onClick={()=>{setNfcEditTag(tag);setNfcEditForm({label:tag.label||'',destination:tag.destination||'setup',user_id:tag.user_id||'',vehicle_id:tag.vehicle_id||''});}} style={{...s.btn,background:'#E8EEF5',color:NAVY,padding:'4px 8px',fontSize:'10px'}}>✏️</button>
                        <button onClick={async()=>{
                          if(!window.confirm('Resetezi tag-ul la setup?'))return;
                          const d=await api('/admin/nfc/'+tag.id+'/reset',{method:'POST'});
                          if(d.message){setMsg('✓ Resetat.');loadNfcTags();setTimeout(()=>setMsg(''),3000);}else setMsg(d.error||'Eroare');
                        }} style={{...s.btn,background:'#FEF3DC',color:GOLD,padding:'4px 8px',fontSize:'10px'}}>🔄</button>
                        <button onClick={async()=>{
                          if(!window.confirm('Ștergi definitiv tag-ul NFC?'))return;
                          const d=await api('/admin/nfc/'+tag.id,{method:'DELETE'});
                          if(d.message){setMsg('✓ Sters.');loadNfcTags();setTimeout(()=>setMsg(''),3000);}else setMsg(d.error||'Eroare');
                        }} style={{...s.btn,background:'#FEE2E2',color:RED,padding:'4px 8px',fontSize:'10px'}}>🗑</button>
                        <button onClick={()=>{navigator.clipboard.writeText('https://dosarmasina.ro/nfc/'+tag.token);setMsg('✓ Link copiat!');setTimeout(()=>setMsg(''),2000);}} style={{...s.btn,background:'#F4F4F4',color:'#555',padding:'4px 8px',fontSize:'10px'}}>🔗</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

    </div>
  );
}
